<button
  class="btn-action  whitespace-nowrap {{ styleClasses }}"
  [class.uppercase]="uppercase"
  [class.large]="large"
  [class.medium]="medium"
  [disabled]="disabled"
  [class.borderless]="borderless"
  (click)="onSubmit($event)">
  @if (withIcon) {
    <i class="icon btn-icon {{ showLoadingIcon ? loadingIconClass : iconClass }}" [class.mr-1]="buttonLabel"></i>
  }
  {{ buttonLabel }}
</button>
